import { Component, HostListener, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl } from '@angular/forms';
import { chooseOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { SelectValue, Department, Screen, Module, SCREEN_CONTROL, ControlStateSource, dropdownsource, ModuleMenu, SCREEN_RESPONSE, SCREEN_RESPONSE_ANSWER, Document_Upload_File, GM_APP, DateObject, ScreenResponseModel } from 'src/app/models/common';
import { Subject } from 'rxjs';
import { stateOptionsSample, moduleslist, serviceConstants } from 'src/app/constants/service.constants';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-dynamic-forms',
  templateUrl: './dynamic-forms.component.html',
  styleUrls: ['./dynamic-forms.component.scss']
})
export class DynamicFormsComponent implements OnInit, IDeactivateComponent {

  formFields;
  chooseoptions = chooseOptionsConstant;
  generalInformationForm = new UntypedFormGroup({});
  recordstatus: string = "New";
  public screencontrols: Screen;
  public controlsList: SCREEN_CONTROL[] = [];
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  screenresponse: SCREEN_RESPONSE[] = [];
  submittedresponse: SCREEN_RESPONSE[] = [];
  responseanser: SCREEN_RESPONSE_ANSWER;
  heading: string = "Add";
  action: Subject<any> = new Subject();
  content: any;
  screenid: string;
  selectColumns: number = 4;
  screencode: string;
  ScreenContextCode: string = "";
  errormsg: string = "";
  appid: string;
  ModuleName: string;
  OrganizationId: string;
  permission: string = "";
  dynomessage: string = "";
  grantsapp: GM_APP;
  menudata: ModuleMenu;
  validationMessage: string = "";
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year: number = this.myDate.getFullYear() + 25;
  timeout: any;
  IsFormToched: boolean = false;
  tooltipValue: any;

  constructor(
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private summaryService: GrantsSummaryService,
    private adminService: AdministrationSummaryService,
    private commonService: CommonService,
    private header: HeadService,
    private router: Router,
    public datepipe: DatePipe,
    public grantsDatashare: GrantsDatashareService,
    public istDataService: IstDataShareService
  ) {
    this.screencode = route.snapshot.params['code'];
    route.params.subscribe(val => {
      if (val.code != this.screencode) {
        this.screencode = val.code;
        this.permission = "new";
        this.getpermissionInit();
        this.getScreensControlslist();
        this.IsFormToched = false;
      }
    });
    this.permission = "new";
    this.getpermissionInit();
  }
  ngOnInit() {
    this.appid = this.commonService.appId
    this.getScreensControlslist();
    setTimeout(() => {
      this.getpermissionInit();
    }, 500);

    if (this.screencode != null && this.screencode != undefined) {
    }
    else {
      this.screencode = "";
    }

    this.NavigateToGenInfo();
    this.commonService.getGlobalDirtyInfo().subscribe((res) => {
      if (res == true) {
        this.IsFormToched = false;
      }
    });
  }
  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }
  getpermissionInit() {

    if (this.screencode.toLowerCase() == "accreddetails") {
      this.dynomessage = "Accreditation details saved successfully";
      this.permission = this.commonService.getPagePermission("GC06").toLowerCase();
      this.ScreenContextCode = "GC06";

    }
    else if (this.screencode.toLowerCase() == "sponsorbenefit") {
      this.dynomessage = "Sponsorship Benefits saved successfully";
      this.permission = this.commonService.getPagePermission("GSP02").toLowerCase();
      this.ScreenContextCode = "GSP02";
    }

    else {
      this.permission = this.commonService.getPagePermission(this.screencode).toLowerCase();
    }

  }
  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  getScreensControlslist() {
    this.heading = "New";
    if (this.appid == "" || this.appid == undefined || this.appid == null) {
      this.appid = "0"
    }
    let Code = this.ScreenContextCode == "" ? this.screencode : this.ScreenContextCode;
    this.summaryService.getScreenControlsList(Code, this.appid).subscribe(summary => {
      this.screencontrols = summary;
      if (this.screencontrols != null && this.screencontrols.SCREEN_CONTROL.length > 0) {
        this.screenid = this.screencontrols.ID;
        for (var i = 0; i < this.screencontrols.SCREEN_CONTROL.length; i++) {
          if (this.screencontrols.SCREEN_CONTROL[i].CONTROL == "4" || this.screencontrols.SCREEN_CONTROL[i].CONTROL == "6" || this.screencontrols.SCREEN_CONTROL[i].CONTROL == "7" || this.screencontrols.SCREEN_CONTROL[i].CONTROL == "10") {
            // var optionvalues = this.screencontrols.SCREEN_CONTROL[i].GROUP_VALUES;
            var optionvalues = this.screencontrols.SCREEN_CONTROL[i].GROUP_VALUES_LIST;
            this.screencontrols.SCREEN_CONTROL[i].ControlValue = "";
            var options = optionvalues;
            // var options = optionvalues.split(',');
            if (options && options.length > 0) {
              this.sourceitems = [];
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];
                  //this.screencontrols[0].SCREEN_CONTROL[i].SourceItems.push(sourceitems);
                  this.sourceitems.push(sourceitems);
                }

              }
              if (this.screencontrols.SCREEN_CONTROL[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }

              this.screencontrols.SCREEN_CONTROL[i].SourceItems = [];
              this.screencontrols.SCREEN_CONTROL[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.screencontrols.SCREEN_CONTROL[i].CONTROL == "5") {
            const now = new Date();
            let formd = "";
            formd = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
            //this.screencontrols.SCREEN_CONTROL[i].ControlValue = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
            this.screencontrols.SCREEN_CONTROL[i].ControlValue = null;
          }
          else {
            this.screencontrols.SCREEN_CONTROL[i].ControlValue = "";
          }
        }
        this.controlsList = this.screencontrols.SCREEN_CONTROL;
        this.controlsList.forEach((item) => {
          if (item.CONTROL == "4") {
            this.UpdateParentChildDetails(item);
          }
        });
        this.getResponse();

      }
    });
  }

  getResponse() {
    //this.screenid
    if (this.appid != null && this.appid != undefined && this.appid != "") {
      let sr = new ScreenResponseModel();
      sr.Id = this.screenid;
      sr.RowId = this.screenid;
      sr.AppId = this.appid;

      this.summaryService.getScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          // this.controlsList = this.screencontrols.SCREEN_CONTROL;
          for (var i = 0; i < this.controlsList.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.controlsList[i].ID);
            if (response != null && response.length > 0) {
              if (this.controlsList[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.controlsList[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.controlsList[i].SourceItems != null && this.controlsList[i].SourceItems != undefined) {
                    for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
                      if (options.indexOf(this.controlsList[i].SourceItems[c].value) > -1) {
                        this.controlsList[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.controlsList[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.controlsList[i].CONTROL == '10') {
                this.controlsList[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.controlsList[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.controlsList[i].ControlValue.push(item);
                  });
                  this.controlsList[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.controlsList[i].ControlValue = [];
                }
              }
              else if (this.controlsList[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.controlsList[i].ControlValue = formd;

                  if (this.controlsList[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.controlsList[i].ControlValue = formd;
                  }
                  // if(this.controlsList[i].DATEFORMATE=='MMM-YYYY')
                  // {
                  //   let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'MMM-yyyy');
                  //   this.controlsList[i].ControlValue = formd;
                  // }
                  // if(this.controlsList[i].DATEFORMATE=='YYYY')
                  // {
                  //   let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'yyyy');
                  //   this.controlsList[i].ControlValue = formd;
                  // }
                }

              }
              else {
                this.controlsList[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.controlsList[i].RESPONSEID = response[0].ID;
              this.controlsList[i].ANSWERID = response[0].SCREEN_RESPONSE_ANSWER[0].ID;
              this.controlsList[i].UploadFiles = response[0].UploadFiles;
              if (this.controlsList[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.controlsList[i].ControlValue }, this.controlsList[i]);
              }
            }
          }
        }

      });
    }
  }

  operations = [
    { name: 'Save', type: 'button', callback: this.save, self: this }
  ]
  onCallbackOperation(opr) {
    opr.callback();
  }

  validateControls(): boolean {
    var isValiddata = true;
    let message = "";
    if (this.controlsList != null && this.controlsList.length > 0) {
      for (var i = 0; i < this.controlsList.length; i++) {
        if (this.controlsList[i].IS_MANDATORY) // 
        {
          if (this.controlsList[i].CONTROL == '8') {
            if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
              var filelist = this.controlsList[i].UploadFiles.filter(function (sec) {
                return sec.Status == "Add" || sec.Status == "Edit";
              });
              if (filelist.length == 0) {
                isValiddata = false;
                //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
                //$("#" + controlName).addClass("ng-touched ng-invalid validate-error");
                //$("#" + controlName).removeClass("ng-untouched ng-valid");
              }
              else {
                //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
                //$("#" + controlName).addClass("ng-untouched ng-valid");
                //$("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
              }
            }
            else {
              isValiddata = false;
              //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
              //$("#" + controlName).addClass("ng-touched ng-invalid validate-error");
              //$("#" + controlName).removeClass("ng-untouched ng-valid");
            }
          }
          if (this.controlsList[i].CONTROL == '6') // Check box
          {
            var temp = this.controlsList[i].SourceItems.filter(function (sec) {
              return sec.Checked == true;
            });
            if (temp.length == 0) {
              isValiddata = false;
              var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
              $("#" + controlName).addClass("ng-touched ng-invalid validate-error");
              $("#" + controlName).removeClass("ng-untouched ng-valid");
              this.errormsg += "<li>" + this.controlsList[i].LABEL + "<br/></li>";
            }
            else {
              var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
              $("#" + controlName).addClass("ng-untouched ng-valid");
              $("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
            }
          }
          else {
            if (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined) {
              isValiddata = false;
              var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
              $("#" + controlName).addClass("ng-touched ng-invalid validate-error");
              $("#" + controlName).removeClass("ng-untouched ng-valid");
              this.errormsg += "<li>" + this.controlsList[i].LABEL + "<br/></li>";
            }
            else {
              var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
              $("#" + controlName).addClass("ng-untouched ng-valid");
              $("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
            }
          }

        }
      }
    }
    this.errormsg = "<ul>" + this.errormsg + "</ul>"
    return isValiddata;
  }
  public validateControlsMsgs(): string {
    this.validationMessage = "";
    if (this.controlsList != null && this.controlsList.length > 0) {
      for (var i = 0; i < this.controlsList.length; i++) {

        if (this.controlsList[i].IS_Dependent_Display == false || this.controlsList[i].IS_Dependent_Enabled == false) {
          continue;
        }

        $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-untouched ng-valid");
        $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-pristine ng-invalid ng-touched validate-error");

        if (this.controlsList[i].CONTROL == "6") {
          let seletedItem = "";
          for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
            if (this.controlsList[i].SourceItems[c].Checked == true) {
              if (seletedItem == "")
                seletedItem = this.controlsList[i].SourceItems[c].value;
              else
                seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
            }
          }
          this.controlsList[i].ControlValue = seletedItem;
          if (this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "10" && this.controlsList[i].IS_MANDATORY) {
          let SelectedValues = this.controlsList[i].ControlValue;
          // if ((SelectedValues == null || SelectedValues == undefined || SelectedValues == "") && this.controlsList[i].NotimesChanged < 2) {
          //   SelectedValues = this.controlsList[i].SUBFIELDNAME;
          // }
          if (SelectedValues == null || SelectedValues == undefined || SelectedValues == "") {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

          }
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined)) {
          let tempVal = this.controlsList[i].ControlValue.trim();
          if (tempVal == "") {
            var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
            this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "4" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "5" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "7" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "8" && this.controlsList[i].IS_MANDATORY) {

          if (this.controlsList[i].UploadFiles == null || this.controlsList[i].UploadFiles == undefined || this.controlsList[i].UploadFiles.length == 0) {
            this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
          else if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined && this.controlsList[i].UploadFiles.length > 0) {
            let fileexits = this.controlsList[i].UploadFiles.filter((f) => {
              return f.Status != 'Delete'
            })[0];
            if (fileexits == undefined || fileexits == null) {
              this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
            }
          }

        }
        if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].IS_MANDATORY && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined) {
          this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.trim();
        }
      }
    }
    return this.validationMessage;
  }
  isDateModified: boolean = false;

  Full_Date: DateObject;

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }


  save() {
    this.errormsg = "";
    var errormsg = this.validateControlsMsgs();
    var uploadData = new FormData();
    let type = 0;
    var menu = this.commonService.getModuleMenu();
    if (errormsg.length == 0) {
      //if (menu != null) {
      if (menu.module === "GRANTSCME")
        type = 1;
      else if (menu.module === "GRANTSSPONSORSHIP")
        type = 2;
      else if (menu.module === "GRANTSCHARITABLE")
        type = 3;
      this.screenresponse = [];
      if (this.controlsList != null && this.controlsList.length > 0) {
        this.screencontrols.SCREEN_CONTROL = this.controlsList;
        for (var i = 0; i < this.controlsList.length; i++) {
          let response = new SCREEN_RESPONSE();
          response["ModuleName"] = type + "";
          response["ScreenCode"] = this.ScreenContextCode;
          response.SCREEN_ID = this.screenid.toString();
          response.SCREEN_CONTROL_ID = this.controlsList[i].ID;
          response.CONTROL_TYPE = this.controlsList[i].CONTROL;
          response.MODULE_ID = this.screencontrols.MODULE_ID.toString();
          response.ROW_ID = this.screenid;
          response.ID = this.controlsList[i].RESPONSEID;
          response.APPLICATION_ID = this.appid;
          response.AUDIT_LOGID = "";
          response["dynamicDateobj"] = this.controlsList[i].dynamicDateobj;
          let answer = new SCREEN_RESPONSE_ANSWER();
          answer.ID = this.controlsList[i].ANSWERID;
          answer.ANSWER = this.controlsList[i].ControlValue;
          answer.ROW_ID = 1;

          if (this.controlsList[i].CONTROL == "6") {
            let seletedItem = "";
            for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
              if (this.controlsList[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.controlsList[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
              }
            }
            answer.ANSWER = seletedItem;
          }
          else if (this.controlsList[i].CONTROL == "8") {
            if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
              for (let j = 0; j < this.controlsList[i].UploadFiles.length; j++) {
                if (this.controlsList[i].UploadFiles[j].Status == "Add") {
                  uploadData.append(this.controlsList[i].UploadFiles[j].ID, this.controlsList[i].UploadFiles[j].File);
                  this.controlsList[i].UploadFiles[j].File = null;
                }
              }
              response.UploadFiles = this.controlsList[i].UploadFiles;
            }
          }
          else if (this.controlsList[i].CONTROL == "10") {
            let SelectedValues = this.controlsList[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              answer.ANSWER = SelectedValues.join(",");
            }
            // else if (this.controlsList[i].SUBFIELDNAME != "" && this.controlsList[i].SUBFIELDNAME != undefined && this.controlsList[i].IsTouched != true) {
            //   SelectedValues = this.controlsList[i].SUBFIELDNAME;
            //   answer.ANSWER = SelectedValues;
            // }
            else {
              answer.ANSWER = "";
            }
            this.controlsList[i].SUBFIELDNAME = "";
          }
          else if (this.controlsList[i].CONTROL == "5") {
            let controlanswer = this.controlsList[i].ControlValue;
            if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              answer.ANSWER = formd;
            }
            else {
              answer.ANSWER = controlanswer;
            }
          }
          response.SCREEN_RESPONSE_ANSWER.push(answer);
          this.screenresponse.push(response);
        }
        uploadData.append("screencode", this.ScreenContextCode);
        uploadData.append("screenresponse", JSON.stringify(this.screenresponse));
        uploadData.append("Appid", this.appid);
        uploadData.append("ModuleName", menu.module);
        this.adminService.screenResponseInsert(serviceConstants.apiURL + 'api/screenresponse/insert', uploadData).subscribe((result) => {
          if (result.Status === 0) {
            this.IsFormToched = false;
            if (this.dynomessage === "")
              this.commonService.SuccessBanner(this.screencontrols.NAME + " saved successfully");
            else
              this.commonService.SuccessBanner(this.dynomessage);
            this.getResponse()

          }
          else {
            if (result.ErrorCode == "NOCHANGES") {
              this.commonService.ValidationBanner("No Changes have been performed");
            }
          }
        });
      }
    }
    else {
      this.commonService.ValidationBanner(errormsg);
    }
    //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Save', content: { heading: '', description: 'Data Saved Successfully.' } } });

    //if(this['self'].conceptProposalForm.valid){
    //  this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Save',content: { heading: '', description: 'Data Saved Successfully.'}}});
    //  this['self'].conceptProposalForm.reset();
    //}
  }

  IsRadioChecked(question: any): void {
    let isError: boolean = false;

    if (question.ControlValue == "" && question.Property.Required) {
      question.Property.TempMessage = question.Property.Message;
      question.Property.ShowMessage = true;
    }
    else {
      question.Property.TempMessage = "";
      question.Property.ShowMessage = false;
    }
  }

  IsCheckBoxChecked(propery: any, question: any): void {
    let isError: boolean = false;
    if (propery != undefined && propery != null) {
      for (var iOpt = 0; iOpt < propery.Options.length; iOpt++) {
        if (propery.Options[iOpt].Checked != null && propery.Options[iOpt].Checked) {
          propery.TempMessage = "";
          propery.ShowMessage = false;
          isError = true;
          break;
        }
      }
    }

    if (!isError) {
      propery.TempMessage = propery.Message;
      propery.ShowMessage = true;
    }
    else {
      propery.TempMessage = "";
      propery.ShowMessage = false;
    }
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });

      //documentattach.UploadFiles = documentattach.UploadFiles.filter(function (sec) {
      //  return sec.Status != "Delete";
      //});
    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  uploadchange(event, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let DiffirentFormates = false;
    let samefileName = false;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let filename = event.target.files[i].name;
      var ext = filename.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;
      let IsValid = true;
      if (filename != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        IsValid = false;
        DiffirentFormates = true;
      }
      if (IsValid) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.CreateGuid();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          samefileName = true;
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");

        } else {
          if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          }
          else {
            if (ques.UploadFiles != null && ques.UploadFiles != undefined && ques.UploadFiles.length > 0) {
              this.commonService.CheckIsFileIsRefereancedInReviw(ques.UploadFiles[0].ID).subscribe((x) => {
                if (x["Status"] == 2 && x["Data"] == false) {
                  this.commonService.ValidationBanner(x["Message"]);
                }

                else {
                  ques.UploadFiles = [];
                  ques.UploadFiles.push(uploadFile);
                }
              });

            }


            else {
              ques.UploadFiles = [];
              ques.UploadFiles.push(uploadFile);
            }
          }

        }

      }
      if (DiffirentFormates) {
        this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");

      }
    }
  }
  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }


  FormToched($event) {
    this.IsFormToched = true;
  }
  canExit() {
    if (this.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question);
  }


  ApplyConditions($event, question) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })


    //default
    if (value != "") {
      this.controlsList.forEach((con) => {
        // con.IS_Dependent_Display = true;
        // con.IS_Dependent_Enabled = true;
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
      });
    }

  }


  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            //displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            //enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            //hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            //disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.controlsList.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  NavigateToGenInfo() {
    let Code = this.ScreenContextCode == "" ? this.screencode : this.ScreenContextCode;
    if (this.appid == "" || this.appid == undefined || this.appid == null) {
      this.appid = "0"
    }
    this.summaryService.getScreenControlsList(Code, this.appid).subscribe(summary => {
      this.screencontrols = summary;

      let menuModule = this.commonService.getModuleMenu();
      switch (menuModule.module) {
        //// GRANTS Charitable
        case "GRANTSCME":
          this.appid = this.commonService.appId;
          if (this.appid == null || this.appid == undefined || this.appid == "") {
            const modalRef1 = this.modalService.open(MessageBoxComponent, {});
            modalRef1.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to ' + this.screencontrols.NAME, operation: { hasConfirm: false } } };
            modalRef1.result.then((result) => {
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/geninfocme'],
                { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants", submodule: menuModule.module, screen_type: "my-applications" } })
            });
            return false;
          }

          break;
        case "GRANTSSPONSORSHIP":
          this.appid = this.commonService.appId;
          if (this.appid == null || this.appid == undefined || this.appid == "") {
            const modalRef2 = this.modalService.open(MessageBoxComponent, {});
            modalRef2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to ' + this.screencontrols.NAME, operation: { hasConfirm: false } } };
            modalRef2.result.then((result) => {
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/genInformsponsorship'],
                { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants", submodule: menuModule.module, screen_type: "my-applications" } })
            });
            return false;
          }


          break;
        case "GRANTSCHARITABLE":
          this.appid = this.commonService.appId;
          if (this.appid == null || this.appid == undefined || this.appid == "") {
            const modalRef3 = this.modalService.open(MessageBoxComponent, {});
            modalRef3.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to ' + this.screencontrols.NAME, operation: { hasConfirm: false } } };
            modalRef3.result.then((result) => {
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/genInformcharitable'],
                { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants", submodule: menuModule.module, screen_type: "my-applications" } })
            });
            return false;
          }

          break;
        case "EAP":
          this.appid = this.commonService.appId;
          if (this.appid == null || this.appid == undefined || this.appid == "") {

          }

          break;
        case "IST":
          this.appid = this.commonService.appId;
          if (this.appid == null || this.appid == undefined || this.appid == "") {
            const modalRef = this.modalService.open(MessageBoxComponent, {});
            modalRef.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to ' + this.screencontrols.NAME, operation: { hasConfirm: false } } };
            modalRef.result.then((result) => {
              this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.appid + '/general_information_request'],
                { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "ist", screen_type: "my-applications" } })
            });
            break;
          }

        default:

          break;
      }
    });
  }
}
